import React, { memo, useEffect, useRef, useState } from 'react'
import './index.less'
import ModalBase from '../ModalBase'
import { Button, Input, message, Typography } from 'antd'
import MiniRichEditor from '../MiniRichEditor'
import { getConfigOne, publishQuesAndAns } from '@/api/modules/community'
import Config from '@/config'

type FeedBackProps = {
    open: boolean
    onClose: () => void
}

const FeedBack: React.FC<FeedBackProps> = memo((props) => {

    const { open, onClose } = props
    const [data, setData] = useState<any>()
    const [title, setTitle] = useState('')
    const [value, setValue] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        return () => {
            setValue('')
            setTitle('')
        }
    }, [open])

    const submit = async () => {
        if (!value || !title) {
            message.warning('标题和内容不能为空')
            return
        }
        try {
            setLoading(true)
            const config = await getConfigOne({ code: 'CODE', type: 'FEEDBACK_BLOG' })
            const url = new URL(Config.osURL!)
            const res = await publishQuesAndAns({
                labCode: config.config.labCode,
                code: config.value,
                chapter: "summary",
                title: title.trim(),
                content: value,
                cooperateUrl: Config.osURL!.replace(url.host, `${config.config.labCode}.${url.host}`) + `/os/${config.value}`,
                labels: [],
                cooperate: false,
                sync: false,
                learn: false
            })
            message.success('提交成功')
            onClose()
        } catch (error: any) {
            message.error(error?.message || '提交失败')
        } finally {
            setLoading(false)
        }
    }

    return <>
        <ModalBase
            open={open}
            onCancel={onClose}
            footer={false}
            width={700}
            title='问题反馈'
            contentPadding='30px'
            titleBottom='10px'
        >
            <Typography.Paragraph >亲爱的用户朋友，感谢您的使用！请输入您的宝贵意见：</Typography.Paragraph>
            <Input style={{ marginBottom: 20 }} value={title} onChange={(e) => setTitle(e.target.value)} placeholder='请输入标题' maxLength={50} showCount></Input>
            <MiniRichEditor
                placeholder='请输入您的宝贵意见'
                onChange={(value: string) => {
                    setValue(value)
                }}
                customToolbarKeys={[
                    {
                        "key": "group-image",
                        "title": "图片",
                        "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z\"></path></svg>",
                        "menuKeys": [
                            "insertImage",
                            "uploadImage"
                        ]
                    }
                ]}
            />
            <div className='os-center' style={{ marginTop: 20 }}>
                <Button type='primary' style={{ minWidth: 88 }} loading={loading} onClick={submit} >提交</Button>
            </div>
        </ModalBase>
    </>
})

export default FeedBack